import WrappedGooglePayButton from './WrappedGooglePayButton';

export default WrappedGooglePayButton;
